import React from 'react';
import { Box } from '@mui/material';
import { CaseFormData, CaseValidation } from 'containers/pages/cases/types';
import { CustomerOption } from 'api/cases/searchCustomers';
import { ConsultantOption } from 'api/cases/searchConsultants';
import { ContactOption } from 'api/cases/searchContacts';
import { StatusOption } from 'api/cases/searchStatuses';
import { GPDOption } from 'api/cases/searchGPD';
import { TagOption } from 'api/cases/searchKeywordsAndReferences';
import CaseInfoSection from 'containers/pages/cases/components/caseForm/CaseInfoSection';
import AssignmentSection from 'containers/pages/cases/components/caseForm/AssignmentSection';
import GPDSection from 'containers/pages/cases/components/caseForm/GPDSection';
import TagsAndConfigSection from 'containers/pages/cases/components/caseForm/TagsAndConfigSection';

interface CaseFormFieldsProps {
	form: CaseFormData;
	valid: CaseValidation;
	mode: 'add' | 'edit' | 'copy';
	handler: {
		onFieldChange: (e: { target: { name: string; value: string } }) => void;
		onCustomerChange: (_event: unknown, value: CustomerOption | null) => void;
		onConsultantChange: (_event: unknown, value: ConsultantOption | null) => void;
		onStatusChange: (_event: unknown, value: StatusOption | null) => void;
		onContactChange: (_event: unknown, value: ContactOption | null) => void;
		onGroupChange: (_event: unknown, value: GPDOption | null) => void;
		onProjectChange: (_event: unknown, value: GPDOption | null) => void;
		onDeliverableChange: (_event: unknown, value: GPDOption | null) => void;
		onKeywordsChange: (_event: unknown, value: TagOption[]) => void;
		onReferencesChange: (_event: unknown, value: TagOption[]) => void;
		onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	};
}

const CaseFormFields: React.FC<CaseFormFieldsProps> = ({ form, valid, mode, handler }) => {
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
			<CaseInfoSection
				form={form}
				valid={valid}
				onFieldChange={handler.onFieldChange}
				onStatusChange={handler.onStatusChange}
			/>
			<AssignmentSection
				form={form}
				valid={valid}
				mode={mode}
				onCustomerChange={handler.onCustomerChange}
				onConsultantChange={handler.onConsultantChange}
				onContactChange={handler.onContactChange}
			/>
			<GPDSection
				form={form}
				onGroupChange={handler.onGroupChange}
				onProjectChange={handler.onProjectChange}
				onDeliverableChange={handler.onDeliverableChange}
			/>
			<TagsAndConfigSection
				form={form}
				onKeywordsChange={handler.onKeywordsChange}
				onReferencesChange={handler.onReferencesChange}
				onCheckboxChange={handler.onCheckboxChange}
			/>
		</Box>
	);
};

export default CaseFormFields;
